module.exports = "/_next/static/public/images/162b79c460592c01fb411a220b4a2a6e-ac331b18587a0d196ec4cdbbe4f54ef1.png";